import { render, staticRenderFns } from "./InstagramCommentHide.vue?vue&type=template&id=626ebdd3"
import script from "./InstagramCommentHide.vue?vue&type=script&lang=js"
export * from "./InstagramCommentHide.vue?vue&type=script&lang=js"
import style0 from "./InstagramCommentHide.vue?vue&type=style&index=0&id=626ebdd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports